export default __webpack_public_path__ + "c0a3483bc181e4bd0a5e50c34e2ed715.png";